import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import AnimateHeight from 'react-animate-height'
import Panel from '../../UniformComponents/Panel'
import Button from '../../UniformComponents/Button'
import InfoAccordion from '../InfoAccordion'
import RecordTag from '../RecordTags'

import './settingsLayout.scss'

@observer
class SettingsLayout extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showFilterPanel: (!!props?.hideFilterAccordion || window.innerWidth > 992),
            showGuideAccordion: false,
        }
    }

    // componentDidMount() {
    //     window.addEventListener('resize', this.checkOverflow)
    // }

    // find height diff of main-menu on overflow
    checkOverflow = () => {
        const { innerWidth } = window
        if (innerWidth > 992) {
            this.setState({ showFilterPanel: true })
        } else this.setState({ showFilterPanel: !!this.props.hideFilterAccordion || false })
    }

    toggleFilterPanel = () => {
        this.setState((prevState) => ({
            showFilterPanel: !prevState.showFilterPanel,
        }))
    }

    toggleGuide = () => {
        this.setState((prevState) => ({
            showGuideAccordion: !prevState.showGuideAccordion,
        }))
    }

    renderPageTitle = (pageTitle, showFilterPanel, hideFilterAccordion) => (
        <div
            className="heading"
            onClick={(e) => {
                !hideFilterAccordion ? this.toggleFilterPanel() : () => {}
            }}
        >
            <h3>{pageTitle}</h3>
            {!hideFilterAccordion && (
                <Fragment>
                    <i className="filter-icon fa-regular fa-bars-filter" />
                    <p className="filter-text">Filters</p>
                    <i className={`panel-toggle-icon fa-regular ${showFilterPanel ? 'fa-chevron-up' : 'fa-chevron-down'}`} />
                </Fragment>
            )}
        </div>
    )

    renderResetBtn = (resetFilter) => (
        <div className="reset-wrapper">
            <hr className="reset-divider" />
            <Button
                cssClass="reset-btn"
                icon="fa-regular fa-arrows-rotate"
                label={i18n.t('reset_filter', 'Reset filters')}
                onClick={resetFilter}
            />
        </div>
    )

    render() {
        const {
            pageTitle, hideFilterAccordion, store,
            settings, renderSettings, upperPanelTitle,
            isTemplate,
        } = this.props
        const { showFilterPanel } = this.state
        return (
            <div id="settings-container" className={`${process.env.USE_NEW_HEADER_UI ? 'survey-view-wrapper' : ''}`}>
                <div className="left-container">
                    <Panel cssClass="filter-panel overflow-visible">
                        {this.renderPageTitle(pageTitle, showFilterPanel, hideFilterAccordion)}

                        <hr className="heading-divider" />

                        {store.survey.metadata.isRapidSurvey && (
                            <InfoAccordion
                                title={`${i18n.t('rapidSurvey.disabledLanguageAccordionTitle')}`}
                                hideChevron
                                show
                            >
                                <p dangerouslySetInnerHTML={{ __html: i18n.t('rapidSurvey.disabledLanguageAccordionBody')}} />
                            </InfoAccordion>
                        )}

                        <br />

                        <AnimateHeight
                            className="filter-wrapper"
                            duration={250}
                            height={showFilterPanel ? 'auto' : 0}
                            contentClassName="filter-content"
                        >
                            {renderSettings(settings.languageOptions)}
                        </AnimateHeight>
                    </Panel>
                </div>
                <div className="right-container">
                    <Panel cssClass="search-panel">
                        <div className="left">
                            <h3>{upperPanelTitle}</h3>
                        </div>
                        {renderSettings(settings.upperPanel)}
                    </Panel>
                    <Panel cssClass="settings-panel">
                        {renderSettings(settings.otherFields)}

                        {isTemplate || !store.settingStoreReady
                            ? null
                            : (
                                <div style={{ marginTop: '32px' }}>
                                    <RecordTag
                                        values={store.recordTags}
                                        availableTags={store.availableTags}
                                        onBlur={store.setTag}
                                        register={this.register}
                                        unregister={this.unregister}
                                    />
                                </div>
                            )}
                        <div className="settings-buttons-panel">
                            {renderSettings(settings.buttonPanel)}
                        </div>

                    </Panel>
                </div>
            </div>
        )
    }
}

export default SettingsLayout
